import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { getQuickLinkIconComponent } from '../../data/dashboard/quickLinksData';
import WorkbenchIconAction from '../common/WorkbenchIconAction';
import { mobileWorkbenchPathsMatch } from '../../utils/mobileIslandLastWorkbenchPath';

const isQuickLinkDisabled = (button) => !button?.link || button.link === '#!' || button.link.startsWith('#');

const MobileIslandDockDefaultQuickLinks = ({
	directLinks,
	showMore,
	drawerOpen,
	highlightPath,
	highlightMore = false,
	onOpenDrawer,
	onCloseSearch,
	onQuickLinkNavigate,
}) => (
	<>
		{directLinks.map((button) => {
			const IconGlyph = getQuickLinkIconComponent(button);
			const disabled = isQuickLinkDisabled(button);
			const isRecentEntry = Boolean(highlightPath && mobileWorkbenchPathsMatch(button.link, highlightPath));

			if (disabled) {
				return (
					<span
						key={button.title}
						className='app-mobile-action-island__link app-mobile-action-island__link--disabled'
						aria-disabled='true'
						title={button.title}
					>
						<IconGlyph className='app-mobile-action-island__glyph' aria-hidden='true' />
					</span>
				);
			}

			return (
				<Link
					key={button.link || button.title}
					to={button.link}
					className={classNames('app-mobile-action-island__link', { 'is-recent-entry': isRecentEntry })}
					aria-label={button.title}
					title={button.title}
					onClick={() => {
						onCloseSearch?.();
						onQuickLinkNavigate?.();
					}}
				>
					<IconGlyph className='app-mobile-action-island__glyph' aria-hidden='true' />
				</Link>
			);
		})}
		{showMore ? (
			<WorkbenchIconAction
				className={classNames('app-mobile-action-island__more', { 'is-recent-entry': highlightMore })}
				icon='ellipsis-h'
				onClick={onOpenDrawer}
				active={drawerOpen}
				title='全部快速入口'
				ariaLabel='全部快速入口'
				ariaExpanded={drawerOpen}
			/>
		) : null}
	</>
);

export default MobileIslandDockDefaultQuickLinks;
